import React, { useMemo, useState } from "react";
import { io } from "socket.io-client";

const SocketContext = React.createContext(null);

export const useSocket = () => React.useContext(SocketContext);

export const SocketProvider = (props) => {

    const [myEmail, setMyEmail] = useState(() => {
    // restore from localStorage if present
    return localStorage.getItem("email") || "";
  });

    const socket = useMemo(() => io("https://turn.pristine.farm"), [])

    const value = {
    socket,
    myEmail,
    setMyEmail, // 🔹 expose setter so Homepage can update it
  };

    return (
        <SocketContext.Provider value={value}>
            {props.children}
        </SocketContext.Provider>
    )

}